export const teamEndpoints = {
  addMember: "/user/invite-team-members",
  getAllMembers: "/user/organization-users",
  editRole: (id) => `/user/edit-role/${id}`,
  deletePendingReq: (id) => `/user/pending-invitation/${id}`,
  acceptInvite: (id) => `/user/accept-invitation/${id}`,
  registerStep1: `/user/register-team-member/1`,
  registerStep2: `/user/register-team-member/2`,
};
